import { render } from "./LockLog.vue?vue&type=template&id=1c45d461&ts=true"
import script from "./LockLog.vue?vue&type=script&lang=ts"
export * from "./LockLog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__